import apiService from 'src/shared/config/apiService';
import { UploadedFile } from 'src/shared/types/uploadedFile';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

export interface GetPresignedUploadUrlPayload {
  rfq_id: number;
  filename: string;
  content_type: string;
  size: number;
  caption?: string;
}

export interface GetPresignedUploadUrlResponse {
  upload_url: string;
  upload_fields: Record<string, string>;
  file: UploadedFile;
}

export const getPresignedUploadUrl = async (
  payload: GetPresignedUploadUrlPayload
): Promise<GetPresignedUploadUrlResponse> => {
  try {
    const { data } = await apiService.post<GetPresignedUploadUrlResponse>(
      `/rfqs/${payload.rfq_id}/file-upload-url`,
      {
        filename: payload.filename,
        content_type: payload.content_type,
        size: payload.size,
        caption: payload.caption
      }
    );

    return data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};
